import { useEffect, useState } from 'react'
import { getDiscoveryCatalog } from '@/api/generateapp'
import type { DiscoveryCatalog } from '@/types'

// One load of the ideas catalogue shared by every Builder Hub view (start
// page, ideas browser, business picker, fill-in-the-blanks). A failed load is
// forgotten so the next mount retries.
let pending: Promise<DiscoveryCatalog> | null = null
let loaded: DiscoveryCatalog | null = null

export function useDiscoveryCatalog(): { catalog: DiscoveryCatalog | null; error: string | null } {
  const [catalog, setCatalog] = useState<DiscoveryCatalog | null>(loaded)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (loaded) return
    let cancelled = false
    pending = pending || getDiscoveryCatalog()
    pending
      .then((c) => {
        loaded = c
        if (!cancelled) setCatalog(c)
      })
      .catch((err: unknown) => {
        pending = null
        console.error('discovery-catalog failed', err)
        if (cancelled) return
        const detail = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail
        setError(detail || 'Could not load ideas. Describe your app in your own words instead.')
      })
    return () => { cancelled = true }
  }, [])

  return { catalog, error }
}
